'use client';

import { Link, usePathname } from '@/i18n/navigation';

export function SiteNavLinks({ links }: { links: ReadonlyArray<{ href: string; label: string }> }) {
  const pathname = usePathname();

  return (
    <div className="nav-links-live">
      {links.map((link) => {
        const isCurrent = pathname === link.href || pathname.startsWith(`${link.href}/`);
        return (
          <Link key={link.href} href={link.href} aria-current={isCurrent ? 'page' : undefined}>
            {link.label}
          </Link>
        );
      })}
    </div>
  );
}
